/**
 * Gets navigationItems list that current user has access to.
 */
export function getNavigationItemsForUser(appSections, sidebarNavigationItems, userHasClaim) {
    if (userHasClaim('Admin')) {
        return sidebarNavigationItems;
    }
    const result = sidebarNavigationItems.map(({ menuItems, ...group }) => ({
        ...group,
        menuItems: menuItems.filter((sectionKey) => userHasClaim(...appSections[sectionKey].claimIds)),
    }));
    return result.filter((item) => item.menuItems.length > 0);
}
